import React, { useState, useEffect, useCallback } from "react";
import { useNavigate , useLocation} from "react-router-dom";
import {makeApiCall} from "../config";
import { successToaster, ErrorToaster } from "../utils/toaster";
import { checkTrail, createFreeTrail } from "../subscription-api";

const AuthContext = React.createContext();
function initialFormValues() {
  return {
    username: "",
    email: "",
    organizationName: "",
    organizationRoll: "",
    password: "",
    listOfUrlAndEnv:[]
  };
}
export const AuthProvider = React.memo(({ children }) => {
  const [eventList, setEventList] = useState([]);
  const [fieldData, setFieldData] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [enableSaveBtn, setEnableSaveBtn] = useState(false);
  const [focus, setFocus] = useState(false);
  const navigate = useNavigate();
  const enableToaster = Boolean(process.env.REACT_APP_NODE_ENV === 'development');
  const location = useLocation();
  const [singInFormValues, setSingInFormValues] = useState(initialFormValues);
  const [subscription, setSubscription] = useState({});

  const handleDelete = async(id) =>{
    try {
      const res = await makeApiCall(`/api/v1/admin/delete`, 'put', {id}, {userId: userInfo._id});
      successToaster(res.message);
      setFocus(!focus);
      return;
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in handle delete", error);
      }
    }
  };
  const handleSaveAll = async() => {
    try {
      setEnableSaveBtn(false);
      const res = await makeApiCall(`/api/v1/admin/add/updatedvalues`, 'post', fieldData, {userId: userInfo._id, hostname: userInfo.defaultURL});
      successToaster(res.message);
      setFocus(true);
      setFieldData([]);
      return ;
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in save all", error);
      }
      setEnableSaveBtn(true);
    }
  };

  const pageInfo = useCallback(async(param)=>{
    try {
      if (!param.defaultURL || !param._id) {
        throw new Error("page info param not set");
      }
      const res = await makeApiCall("/api/v1/admin/all", 'get', null, {hostname: param.defaultURL, customerId: param._id});
      enableToaster && successToaster(res.message);
      setEventList(res?.data);
      return true;
    } catch (error) {
      if (error.response && error.response.status === 422) {
        enableToaster && ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in page info", error);
      }
      return false;
    }
  }, [focus])

  async function register(params) {
    try {
      const response = await makeApiCall("/api/v1/auth/register", 'post', params);
      const { accessToken, message,code } = response;
      localStorage.setItem("x-access-token", accessToken);
      successToaster(message);
      await createFreeTrail();
      return code;
    } catch (error) {
      navigate("/auth/signin");
      if (error.response && error.response.status === 422) {
        enableToaster && ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in register form", error);
      }
    }
  }

  const getUserInfo = useCallback(async()=>{
    try {
      const response = await makeApiCall("/api/v1/user/get/", 'get');
      const { data,message } = response;
      setUserInfo(data);
      enableToaster && successToaster(message);
      setFocus(!focus);
      const checkTrailStatus = await checkTrail(data?._id);
      setSubscription(checkTrailStatus);
      return data;
    } catch (error) {
      if (error.response && error.response.status === 422) {
        enableToaster && ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in register form", error);
      }
      return false;
    }
  }, [focus])

  async function signIn(params) {
    try {
      const response = await makeApiCall("/api/v1/auth/signin", 'post', params);
      const { accessToken } = response;
      localStorage.setItem("x-access-token", accessToken);
      
      if (Boolean(localStorage.getItem("x-access-token"))) {
        await getUserInfo();
      }
      navigate("/dashboard");
      successToaster("welcome to home page");
      return true;
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        console.log("Error occurred in singIn form", error);
      }
      return false;
    }
  }

  async function signOut(pathname = "/auth/signin") {
    localStorage.removeItem("x-access-token");
    navigate(pathname);
  }

  useEffect(() => {
      if (!location.pathname.startsWith("/auth/verify")) {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      (async()=>{
        if (token) {
            localStorage.setItem('x-access-token', token);
            navigate("/dashboard/default");
        }
        console.log("authorization token", localStorage.getItem("x-access-token"));
        if (!Boolean(localStorage.getItem("x-access-token"))) {
          signOut("/auth/signin");
        }
        if(Boolean(localStorage.getItem("x-access-token")) && location.pathname.startsWith("/auth")){
          navigate("/dashboard/default");
        }
      })()
      // if (Boolean(localStorage.getItem("x-access-token")) && !location.pathname.startsWith("/auth/signin")) {
      //  const userData = await getUserInfo();
      //   await pageInfo(userData);
      // }
    }
  }, [localStorage.getItem("x-access-token")]);
  return (
    <AuthContext.Provider
      value={{
        signIn,
        signOut,
        register,
        pageInfo,
        userInfo,
        setUserInfo,
        eventList,
        enableSaveBtn,
        handleDelete,
        handleSaveAll,
        focus,
        setFocus,
        setEnableSaveBtn,
        setEventList,
        fieldData, 
        setFieldData,
        enableToaster,
        singInFormValues,
        setSingInFormValues,
        getUserInfo,
        subscription
      }}
    >
      {children}
    </AuthContext.Provider>
  );
});

export default AuthContext;
